import { css } from 'styled-components';

export const bold28 = css`
  font-family: Pretendard;
  font-size: 2.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 4.2rem;
  letter-spacing: -0.028rem;
`;

export const bold24 = css`
  font-family: Pretendard;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 3.6rem;
  letter-spacing: -0.028rem;
`;

export const regular24 = css`
  font-family: Pretendard;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3.6rem;
  letter-spacing: -0.024rem;
`;

export const bold20 = css`
  font-family: Pretendard;
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 3rem;
  letter-spacing: -0.02rem;
`;

export const regular20 = css`
  font-family: Pretendard;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3rem;
  letter-spacing: -0.02rem;
`;

export const bold18 = css`
  font-family: Pretendard;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.8rem;
  letter-spacing: -0.018rem;
`;

export const regular18 = css`
  font-family: Pretendard;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.018rem;
`;

export const bold16 = css`
  font-family: Pretendard;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.6rem;
  letter-spacing: -0.016rem;
`;

export const regular16 = css`
  font-family: Pretendard;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.6rem;
  letter-spacing: -0.016rem;
`;

export const regular15 = css`
  font-family: Pretendard;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.2rem;
  letter-spacing: -0.015rem;
`;

export const bold15 = css`
  font-family: Pretendard;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: -0.015rem;
`;

export const regular14 = css`
  font-family: Pretendard;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: -0.007rem;
`;

export const bold14 = css`
  font-family: Pretendard;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: -0.007rem;
`;

export const regular12 = css`
  font-family: Pretendard;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.8rem;
  letter-spacing: -0.006rem;
`;
